import { HttpClient } from '@angular/common/http';
import { Injectable, TemplateRef, inject } from '@angular/core';
import { Notification, Query } from '@wdx/clmi/clmi-swagger-gen';
import { PaginatedApiResponse } from '@wdx/clmi/api-services/models';
import { ApiPaginationService } from '@wdx/shared/infrastructure/api-service';
import { Observable } from 'rxjs';
import { PaginationOptions } from '../../models/pagination-options';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class NotificationsService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);
    private apiPaginationService = inject(ApiPaginationService);

    private notificationToastTemplate: TemplateRef<any> | null = null;
    private notificationToastHeaderTemplate: TemplateRef<any> | null = null;

    getPage(
        paginationOptions: PaginationOptions,
    ): Observable<PaginatedApiResponse<Notification>> {
        return this.http.get<PaginatedApiResponse<Notification>>(
            `${this.config.getConfiguration().API_BASE}/user/me/notification`,
            {
                headers:
                    this.apiPaginationService.mapPaginationOptions(
                        paginationOptions,
                    ),
            },
        );
    }

    getForView(
        filters: Query,
        paginationOptions: PaginationOptions,
    ): Observable<PaginatedApiResponse<Notification>> {
        return this.http.post<PaginatedApiResponse<Notification>>(
            `${this.config.getConfiguration().API_BASE}/query/notification`,
            filters,
            {
                headers:
                    this.apiPaginationService.mapPaginationOptions(
                        paginationOptions,
                    ),
            },
        );
    }

    markAsRead(notifications: Notification[]): Observable<void> {
        const ids = notifications?.map((notification) => notification.id);
        return this.http.patch<void>(
            `${this.config.getConfiguration().API_BASE}/notification/read`,
            ids,
        );
    }

    markAllAsRead(): Observable<void> {
        return this.http.patch<void>(
            `${this.config.getConfiguration().API_BASE}/user/me/notification`,
            {},
        );
    }

    setNotificationToastTemplate(template: TemplateRef<any>): void {
        this.notificationToastTemplate = template;
    }

    getNotificationToastTemplate(): TemplateRef<any> | null {
        return this.notificationToastTemplate;
    }

    setNotificationToastHeaderTemplate(template: TemplateRef<any>): void {
        this.notificationToastHeaderTemplate = template;
    }

    getNotificationToastHeaderTemplate(): TemplateRef<any> | null {
        return this.notificationToastHeaderTemplate;
    }
}
